import { Row, Col, Input, Button } from 'reactstrap';
import Select from 'react-select';
import { CustomReactSelectStyles } from 'pages/Promotions/styles/customStyles';
import {
  ActiveStatusOptionsFilter,
  FREE_GIFT_ALLOWED_STORE_IDS,
  PromoTypesFilter,
} from 'pages/Promotions/PromoConstant';
import { UserInfo } from 'types/info/user';
import { SelectedData } from 'types/common/FormTypes';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { RootState } from 'slices';
import { setPageFilters } from 'slices/promotions/reducer';

interface PromotionSearchFormProps {
  isDarkMode: boolean;
  onSubmit: (value: {
    promotionName: string;
    promoType: string;
    promoStatus: string;
  }) => void;
}

const PromotionSearchForm = ({
  isDarkMode,
  onSubmit,
}: PromotionSearchFormProps) => {
  const { t } = useTranslation();
  const promotionsState = useSelector((state: RootState) => state.Promotions);
  const { PageFilters } = promotionsState;
  const infoUser = useSelector(
    (state: RootState) => state.Info.user
  ) as UserInfo;
  const showFreeGift = FREE_GIFT_ALLOWED_STORE_IDS.includes(
    infoUser?.store_id_login
  );
  const dispatch = useDispatch();
  const formik = useFormik({
    initialValues: PageFilters,
    enableReinitialize: true,
    onSubmit: (values) => {
      onSubmit(values);
      dispatch(setPageFilters(values));
    },
  });

  return (
    <form onSubmit={formik.handleSubmit} data-testid="promotionSearchForm">
      <Row>
        <Col md={8} lg={3} className="col-xxl-3 px-2 mx-1">
          <div className={`search-box me-2 mb-2 `}>
            <Input
              type="text"
              name="promotionName"
              placeholder={t('SearchPromoName')}
              value={formik.values.promotionName}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              style={{ height: 38 }}
              data-testid="search-form-promotionName"
            />
            <i className="bx bx-search-alt search-icon"></i>
          </div>
        </Col>
        <Col md={4} lg={3} className="col-xxl-2 px-2 mx-1">
          <div className="me-2 mb-2" data-testid="search-form-promoType">
            <Select
              styles={CustomReactSelectStyles(isDarkMode)}
              value={
                formik.values.promoType
                  ? PromoTypesFilter(t, showFreeGift)
                      .flatMap((group) => group.options)
                      .find(
                        (option: { value: string }) =>
                          option.value === formik.values.promoType
                      )
                  : PromoTypesFilter(t, showFreeGift)
                      .flatMap((group) => group.options)
                      .find((option: { value: string }) => option.value === '')
              }
              onChange={(option: SelectedData) =>
                formik.setFieldValue('promoType', option.value)
              }
              onBlur={() => formik.setFieldTouched('promoType', true)}
              options={PromoTypesFilter(t, showFreeGift)}
              aria-label="promoType"
              name="promoType"
              placeholder={t('FilterByPromotionType')}
            />
          </div>
        </Col>

        <Col md={4} lg={3} className="col-xxl-2 px-2 mx-1">
          <div className="me-2 mb-2" data-testid="search-form-promoStatus">
            <Select
              styles={CustomReactSelectStyles(isDarkMode)}
              value={
                formik.values.promoStatus
                  ? ActiveStatusOptionsFilter(t).find(
                      (option: { value: string }) =>
                        option.value === formik.values.promoStatus
                    )
                  : ActiveStatusOptionsFilter(t).find(
                      (option: { value: string }) => option.value === ''
                    )
              }
              onChange={(option: SelectedData) => {
                formik.setFieldValue('promoStatus', option.value);
              }}
              onBlur={() => formik.setFieldTouched('promoStatus', true)}
              options={ActiveStatusOptionsFilter(t)}
              name="promoStatus"
              aria-label="promoStatus"
              placeholder={t('FilterByStatus')}
            />
          </div>
        </Col>

        <Col md={2} lg={2} className="col-xxl-1">
          <Button
            color="success"
            type="submit"
            outline
            data-testid="search-form-btn-submit"
          >
            {t('Search')}
          </Button>
        </Col>

        {/* <Col sm={4} className="col-xxl-1"></Col> */}
      </Row>
    </form>
  );
};
export default PromotionSearchForm;
